import React from 'react';
import Reflux from 'reflux';
import EventViewStore from 'flux/stores/EventViewStore';
import AlertBar from 'shared/components/misc/alertBar.jsx';
import moment from 'moment';

/**
 * Pending Readonly Alert bar
 *
 */
export default React.createClass({
  mixins: [Reflux.connect(EventViewStore, 'event')],

  displayName: 'PendingReadOnlyAlertBar',

  render() {
    let { event } = this.state;

    var format = 'MMM Do, YYYY';
    var endOn = moment(event.get('endOn'));

    if (!this._isVisible()) return null;

    let message =
      `This event ended on ${endOn.format(format)} ` +
      ` and will go into READ ONLY MODE on ${endOn
        .hour(0)
        .add(7, 'days')
        .format(format)}`;

    return (
      <div className="pending-read-only-alert-bar">
        <AlertBar
          type="warning"
          message={message}
          dismissible
          onDismiss={this._handleClose}
        />
      </div>
    );
  },

  _handleClose() {
    this.setState({ hidden: true });
  },

  _isVisible() {
    let { event } = this.state;

    const endOn = moment(event.get('endOn'));
    const now = moment().hour(0).minute(0);
    const oneDayAgo = now.clone().subtract(1, 'day');
    const sevenDaysAgo = now.clone().subtract(7, 'days');

    return (
      !this.state.hidden &&
      endOn.isAfter(sevenDaysAgo) &&
      endOn.isBefore(oneDayAgo)
    );
  },
});
